<template>
  <div>
    <vg-card>
      <vg-form>
        <vg-field
            label="公共区域"
            readonly
            is-link
            @click="pickPublic"
        />
      </vg-form>
    </vg-card>
    <vg-collapse-panel
        title="租户区域"
        fixed-on
    >
      <vg-card class="hidden">
        <van-search
            class="search"
            placeholder="输入地址/租户名称/品牌名称进行搜索"
            show-action
            v-model="searchValue"
        >
          <template #action>
            <vg-button class="primary small" @click="choiceSelect">
              搜索
            </vg-button>
          </template>
        </van-search>
      </vg-card>
      <vg-card v-if="locations.length > 0" class="padding">
        <vue-tree-list class="tree"
                       @click="onClick"
                       :model="tree"
                       :default-expanded="true"
                       :delNodeDisabled="true">
          <!-- 先把icon order改为 -1 排在最前面，然后再根据层级计算icon宽度作为缩进宽度 -->
          <template v-slot:treeNodeIcon="slotProps">
            <span :style="{display: 'inline-block', width: slotProps.model.level*20 + 'px'}"></span>
          </template>
          <template v-slot:leafNodeIcon="slotProps">
            <span :style="{display: 'inline-block', width: slotProps.model.level*20 + 'px'}"></span>
          </template>
          <!-- <span class="icon" slot="addTreeNodeIcon">📂</span>
          <span class="icon" slot="addLeafNodeIcon">＋</span>
          <span class="icon" slot="editNodeIcon">📃</span>
          <span class="icon" slot="delNodeIcon">✂️</span>
          <span class="icon" slot="leafNodeIcon">🍃</span> -->
          <!--          <span class="icon" slot="treeNodeIcon">🌲</span>-->
        </vue-tree-list>
      </vg-card>
      <template v-else>
        <div style="text-align: center; margin-top: 20px;">
          <van-image width="150" height="150" :src="defaultLogo"/>
        </div>
        <div style="text-align: center;margin-top: 20px; margin-bottom: 20px;">
          <span v-if="!searchValue">请输入搜索条件查找租户区域施工位置</span>
          <br/>
          <span v-if="searchValue && locations.length < 1">未找到施工位置，请重新输入正确的搜索内容</span>
        </div>
      </template>
    </vg-collapse-panel>
  </div>
</template>
<script>
import defaultPicture from "@/assets/myElectronicPass/defaultPicture.png";
import {Image, Search} from "vant";
import {VueTreeList, Tree} from 'vue-tree-list';
import useConstructionLocationPickerStore from "@/store/construction-location-picker-store";
import {mapState} from "pinia";
import VgCard from "@/components/Commons/VgCard.vue";
import VgForm from "@/components/Commons/VgForm.vue";
import VgField from "@/components/Commons/VgField.vue";
import VgCollapsePanel from "@/components/Commons/VgCollapsePanel.vue";
import VgButton from "@/components/Commons/VgButton.vue";

export default {
  name: "ConstructionLocationPickerView",
  components: {
    VgButton,
    VgCollapsePanel,
    VgField,
    VgForm,
    VgCard,
    'vue-tree-list': VueTreeList,
    'van-search': Search,
    'van-image': Image
  },
  props: {},
  data() {
    return {
      searchValue: null,
      defaultLogo: defaultPicture,
    };
  },
  computed: {
    ...mapState(useConstructionLocationPickerStore, ["locations"]),
    tree() {
      console.log('treeeeeeeeee')
      console.log(this.locations)
      return new Tree(this.locations);
    }
  },
  methods: {
    choiceSelect() {
      if (!this.searchValue || this.searchValue.length <= 0) {
        this.$toast('搜索租户区域最少输入1个字符，请重新输入')
        return
      }
      useConstructionLocationPickerStore()
          .initAndSearch(this.$route.params.cheetahId, this.searchValue)
    },
    choiceTenant() {
      this.$router.go(-1)
    },
    pickPublic() {
      // eventBus.$emit('CONSTRUCTION_LOCATION','公共区域');
      useConstructionLocationPickerStore().pick('公共区域')
      this.$router.go(-1)
    },
    onClick(params) {
      console.log(params)
      if (!params.isLeaf) {
        params.toggle()
        return
      }
      useConstructionLocationPickerStore().pick(params.name)
      this.$router.go(-1)
      console.log(params)
      console.log("onClick")
    },
  },
};
</script>
<style scoped>

.search {
  padding: 0;
}

.search >>> .van-search__content {
  border-radius: 8px;
  height: 30px;
  padding: 0;
  border: 1px solid #E7E5E7;
  background-color: #FFFFFF;
}

.search >>> .van-search__action {
  padding: 0;
  margin: 0 0 0 10px;
}

.search >>> .vg-button {
  height: 30px;
}

.content {
  /* border: 1px solid #E7E5E7;
  border-radius: 5px; */
  margin: 10px 12px 0px 12px;
}

.tenantArea {
  border: 1px solid #E7E5E7;
  border-radius: 5px;
  margin-top: 10px;
}

.choice-list {
  width: 353px;
  border: 1px solid #E7E5E7;
  border-radius: 5px;
  margin-left: 25px;
  margin-top: 20px;
}

.title {
  border: 1px solid #E7E5E7;
  border-radius: 5px;
}

.choice-tenant-button {
  width: 70px;
  height: 36px;
  float: right;
  margin-top: -40px;
  margin-right: 40px;
}

.choice-tenant-search >>> .van-icon-search:before {
  content: '';
}

.choice-tenant-search {
  width: 275px;
  height: 44px;
  /* float: left; */
}

.choice-tenant-search >>> .van-search__content {
  border: 1px solid #E7E5E7;
  background-color: white;
  padding-left: 0px;
}

.vg-view-field-value {
  margin-left: 10px;
}

.vg-view-field-label {
  /*margin-bottom: 6px;*/
  /*font-size: 16px;*/
  /*font-weight: 600;*/
  color: #B4B4B4;
  line-height: 22px;
  flex-shrink: 0;
  /*font-weight: bold;*/
}

.vg-view-field-value {
  /*min-height: 20px;*/
  /*font-size: 14px;*/
  /*font-weight: 600;*/
  /*color: #333333;*/
  line-height: 20px;
}

/*节点样式*/
.tree >>> .vtl-node {
  border-top: solid 1px #E7E5E7;
  padding: 10px 0;
  font-size: 14px;
  color: #000;
}

/*第一个节点的上边框*/
.tree >>> > div > div.vtl > .vtl-node {
  border-top: none;
}

.tree >>> .vtl-node-main,
.tree >>> .vtl-node-main .vtl-caret {
  margin: 0;
  padding: 0;
}

.tree >>> .vtl-node-main .vtl-caret + * {
  order: -1;
}


.tree >>> .vtl-border {
  display: none;
}

.tree >>> .vtl-menu-icon {
  display: none;
}


.tree >>> .vtl-node-main {
  box-sizing: border-box;
  position: relative;
  background: #FFFFFF;
}

/*每个节点样式*/
.tree >>> .vtl-tree-margin {
  margin: 0 0 0 0px;
}

.tree >>> .vtl-border.vtl-up {

}

.vg-view-field {
  padding: 8px 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vg-view-field.vertical {
  align-items: flex-start;
  flex-direction: column;
}

.vg-view-field.vertical .vg-view-field-value {
  margin: 5px 0 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 5px;
}

.vg-view-field.primary .vg-view-field-value {
  color: #4BA9F6;
}

.vg-view-field.error .vg-view-field-value {
  color: #FF3434;
}
</style>
  